import {
  LOADING_SHOW,
  LOADING_HIDE,
  MODAL_SHOW,
  MODAL_HIDE,
  RESPONSE_SHOW,
  SNACKBAR_SHOW,
  SNACKBAR_HIDE,
  LOADING_PAGE,
  LOADED_PAGE,
} from '../constants/actionTypes';

const doShowLoading = () => ({
  type: LOADING_SHOW,
});

const doHideLoading = () => ({
  type: LOADING_HIDE,
});

const doShowModal = target => ({
  type: MODAL_SHOW,
  target,
});

const doHideModal = () => ({
  type: MODAL_HIDE,
});

const doShowResponse = (type, text) => ({
  type: RESPONSE_SHOW,
  payload: {
    type,
    text,
  },
});

const doShowSnackbar = (type, text) => ({
  type: SNACKBAR_SHOW,
  payload: {
    type,
    text,
  },
});

const doHideSnackbar = () => ({
  type: SNACKBAR_HIDE,
});

const doLoadingPage = () => ({
  type: LOADING_PAGE,
});

const doLoadedPage = () => ({
  type: LOADED_PAGE,
});

export {
  doShowLoading,
  doHideLoading,
  doShowModal,
  doHideModal,
  doShowResponse,
  doShowSnackbar,
  doHideSnackbar,
  doLoadingPage,
  doLoadedPage,
};
